<script setup lang="ts">
defineProps({
  fill: {
    type: String as PropType<string>,
    required: false,
    default: '#EAC93A',
  },
  width: {
    type: String as PropType<string>,
    required: false,
    default: '53',
  },
  height: {
    type: String as PropType<string>,
    required: false,
    default: '3',
  },
})
</script>

<template>
  <svg
    width="53"
    height="3"
    viewBox="0 0 53 3"
    fill="#EAC93A"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      :width="width"
      :height="height"
      :fill="fill"
    />
  </svg>
</template>
